import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  storageProviders = ['S3', 'hsbShare'];
  exporterSelectedStorageProvider = this.storageProviders[0];
  mapTransformSelectedStorageProvider = this.storageProviders[0];

  constructor(private router:Router) {}

  ngOnInit() {
  }
  navigateTo(link)
  {
    this.router.navigate([link]);
  }


}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts